export default {
  middleware_url: "https://exliv.fluid-it.fr",
  cake_url: "https://exliv.cake.fluid-it.fr",
  pwa_url: "https://app.exliv.fluid-it.fr",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
  billingConforamaEnabled: false,
  showLockBillingButton: true,
  useRatingSystem: true,
  useMapPage: true,
  useGpsTracking: true,
  instancePrefix: "15",
  googleMap: {
    api: "AIzaSyDLZwfjCBY-UQv7KtYGqZO_m6Jrlx4JYq4",
  },
};
